/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  constants.ts
 */

import { APTS_BASE_URL } from '@zcode/nr-utils'

const airbnbFriendlyMarkets = [
  'chandler-az',
  'phoenix-az',
  'scottsdale-az',
  'tempe-az',
  'alameda-ca',
  'burlingame-ca',
  'canyon-country-santa-clarita-ca',
  'chula-vista-ca',
  'fremont-ca',
  'glendale-ca',
  'long-beach-ca',
  'mission-viejo-ca',
  'ontario-ca',
  'pasadena-ca',
  'rancho-santa-margarita-ca',
  'redwood-city-ca',
  'san-diego-ca',
  'san-francisco-ca',
  'san-jose-ca',
  'san-mateo-ca',
  'santa-clara-ca',
  'solana-beach-ca',
  'valencia-ca',
  'castle-rock-co',
  'denver-co',
  'lafayette-co',
  'tampa-fl',
  'atlanta-ga',
  'kennesaw-ga',
  'cambridge-ma',
  'bethesda-md',
  'gaithersburg-md',
  'silver-spring-md',
  'charlotte-nc',
  'raleigh-nc',
  'hoboken-nj',
  'west-new-york-nj',
  'addison-tx',
  'austin-tx',
  'cedar-park-tx',
  'dallas-tx',
  'frisco-tx',
  'houston-tx',
  'irving-tx',
  'lewisville-tx',
  'round-rock-tx',
  'the-woodlands-tx',
  'alexandria-va',
  'arlington-va',
  'herndon-va',
  'bellevue-wa',
  'bothell-wa',
  'martha-lake-wa',
  'mill-creek-wa',
  'redmond-wa',
  'lynnwood-wa',
  'everett-wa',
  'philadelphia-pa',
  'north-bethesda-md',
  'norfolk-va',
  'santa-rosa-beach-fl',
  'oklahoma-city-ok',
  'oak-hills-place-la',
  'hammond-la',
  'sarasota-fl',
  'plano-tx',
  'prescott-valley-az',
  'petaluma-ca',
  'portland-or',
  'silverdale-wa',
  'bellingham-ma',
  'south-portland-me',
  'rocky-hill-ct',
  'citrus-heights-ca',
  'fresno-ca',
  'stamford-ct',
  'lexington-park-md',
  'panama-city-beach-fl',
  'aurora-co',
  'wakefield-ri',
  'oviedo-fl',
  'kemah-tx',
  'windermere-fl',
  'arlington-heights-il',
  'fayetteville-nc',
  'richfield-mn',
  'tulsa-ok',
  'tewksbury-ma',
  'san-antonio-tx',
  'loveland-oh',
  'frankfort-ky',
  'loveland-co',
  'greeley-co',
  'speedway-in',
  'murfreesboro-tn',
  'indianapolis-in',
  'spring-hill-tn',
  'leland-nc',
  'edmond-ok',
  'riverview-fl',
  'marietta-ga',
  'euless-tx',
  'north-richland-hills-tx',
  'mckinney-tx',
  'alpharetta-ga',
  'northdale-fl',
  'madison-al',
  'sunset-beach-nc',
  'durham-nc',
  'nashville-tn',
  'memphis-tn',
  'miami-fl',
  'suwanee-ga',
  'cypress-tx',
  'columbus-oh',
  'saint-louis-mo',
  'lawrenceville-ga',
  'collierville-tn',
] as const

export const airBnbFriendlyPathnames = airbnbFriendlyMarkets.map((market) => {
  return `/${APTS_BASE_URL}/${market}` as const
})

// optmizely constants
export const ZOE_MAP_LIST_V2 = 'ZOE_MAP_LIST_V2'
export const SHOW_ZOE = 'SHOW_ZOE'
export const SHOW_ZOE_AUTOCOMPLETE_DEFAULT = 'SHOW_ZOE_AUTOCOMPLETE_DEFAULT'
